// utils.ts

import { submitLeadFormData } from '@/lib/lead-submission';
// Build initial form values with hidden fields
export const buildInitialValues = (
  hiddenFields: Array<{ key: string; value: string }> = [],
  defaultValues: any,
) => ({
  ...defaultValues,
  ...Object.fromEntries(hiddenFields.map((field) => [field.key, field.value])),
});

// Submit form data to API
export const submitFormData = async (values: any) => {
  const formattedData = {
    LastName: values.lastName,
    FirstName: values.firstName,
    Email: values.email,
    UTM_Parameter__c: 'nl_sb',
    Tech_Data_Origin__c: 'W2L',
    LeadSource: 'Website',
    Source_URL__c: 'https://smzh.ch/de',
    HasOptedOutOfEmail: true,
    Add_to_Campaign__c: true,
  };

  // Create a FormData object
  const formData = new FormData();
  Object.entries(formattedData).forEach(([key, value]) => {
    formData.append(key, value as string);
  });

  try {
    const response = await submitLeadFormData(formData);

    return response.ok;
  } catch (error) {
    console.error('Form submission error:', error);
    return false;
  }
};
